module.exports = __webpack_public_path__ + "static/b1-ui-646072e22401a1fde7741b4f00c63a21.jpg";